import { constructTheme } from 'assets/helpers';
import { useState } from 'react';

export const useCurrentTheme = () => {
  const [currentTheme] = useState(constructTheme());

  return currentTheme;
};
